import { render, staticRenderFns } from "./EditStudentInformation.vue?vue&type=template&id=ffe031d4&scoped=true&"
import script from "./EditStudentInformation.vue?vue&type=script&lang=js&"
export * from "./EditStudentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe031d4",
  null
  
)

export default component.exports